import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {AndroidIcon, IphoneIcon, GameIcon, CustomSoftIcon, SoftwareProIcon, SoftwareMainIcon} from "../../../app-constants";
import { Link } from 'gatsby'; // Import Gatsby's Link component
import HtmlParser from 'react-html-parser';


const StackItem = [
    {
        icon: AndroidIcon,
        title: 'Android app development',
        description: (
            <>
                TekRevol stands as a top-tier{' '}
                <Link to="/android-app-development" rel="noopener" aria-label="TekRevol">
                    Android app development company
                </Link> {' '}
                in Austin, specializing in the creation of custom software development that fully utilizes the potential of the most popular mobile platform globally. Utilizing a versatile tech stack that includes Java or Kotlin, we transform your app concepts into reality with a focus on precision and creativity. Our seasoned Android developers intricately craft and construct apps customized specifically for the Android ecosystem.
            </>
        ),
    },
    {
        icon: IphoneIcon,
        title: 'Iphone app development',
        description: (
            <>
                Indulge in the utmost refinement with TekRevol's native{' '}
                <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
                    iOS app development services.
                </Link> {' '}
                 Our proficient iOS developers are committed to crafting apps that embody the sophistication and flawless performance that iOS users anticipate. We meticulously consider every aspect to guarantee your app seamlessly aligns with Apple's design principles. Prioritizing user experience and technical prowess, our iOS applications provide the audience a seamless experience of interacting with any business online.
            </>
        ),
    },
    {
        icon: GameIcon,
        title: 'Game app development',
        description: (
            <>
                Choose from Unity and Unreal engine game development, diversify in niche-based content, and leverage emerging tech like AR and VR to launch a high-performing game. We are an experienced and creative{' '}
                <Link to="/game-development" rel="noopener" aria-label="TekRevol">
                    game app development company
                </Link> {' '}
                boarded with seasoned game developers who are well-versed in what it takes to create highly immersive 2D/3D games. There are multiple types of games that we build utilizing these technologies to the best extent of our expertise.
            </>
        ),
    },
    {
        icon: CustomSoftIcon,
        title: 'Custom Software Development',
        description: (
            <>
                Our{' '}
                <Link to="/custom-software-development" rel="noopener" aria-label="TekRevol">
                    Custom software development services
                </Link> {' '}
                provide personalized solutions for enterprises and institutions seeking to tackle precise requirements and obstacles. These services encompass the creation, design, and deployment of software applications and systems, meticulously designed to align with the client's goals. The key benefit lies in the capacity to develop software that facilitates a business's specific demands and operations.
            </>
        ),
    },
    {
        icon: SoftwareProIcon,
        title: 'Software Product Development',
        description: "We offer software product development services that cover the complete journey of conceptualizing, designing, constructing, and introducing software products. They are crucial for businesses aiming to convert inventive ideas into practical, market-ready software products. Our software product development will provide you with a competitive advantage through distinctive, user-centric, and market-ready software solutions.",
    },
    {
        icon: SoftwareMainIcon,
        title: 'Software Support and Maintenance',
        description: "You can have our software support and maintenance services to ensure smooth and dependable operation of software applications. From performance enhancement to security updates and feature enrichment, spect comes under this service. Whether there are routine updates to keep pace with evolving technology or responsive technical assistance as per requirement, software support and maintenance services form the foundation for preserving software performance.",
    },

];

function Improvise(props) {
    return (
        <div className="improvise_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                <Col xs={12} md={12} lg={12} xl={10} xxl={4} className="m-xl-auto m-xxl-0">
                        <h2>TekRevol's App and Software Development Services in Austin</h2>
                        <p className="impro_para">We help global businesses positively impact their functional ecosystems with targeted investments in the right technical talent and tools. Our promise of innovation qualifies us as one of the most highly experienced custom software development services in Austin.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
                        <div className="stack_box">
                            {StackItem.map((item, index) => (
                                <div className="stack_item" key={index}>
                                    <div className="stack_title">
                                        {item.icon}
                                        <h5>{item.title}</h5>
                                    </div>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Improvise;